import type { FirestoreCustomPackageDocument } from '@/shared/types/custom-package.types'

import { useFirestoreCollection } from './useFirestoreCollection'

interface UseCustomPackagesResult {
  customPackages: FirestoreCustomPackageDocument[]
  loading: boolean
  error: Error | null
}

/**
 * Hook to fetch custom packages from Firestore for a specific building UUID
 * Returns custom packages sorted by creation date (newer to older)
 * @param buildingUuid - The UUID of the building
 * @returns Custom packages data, loading state, and error
 */
export function useCustomPackages(buildingUuid: string | undefined): UseCustomPackagesResult {
  const path = buildingUuid ? `/assessments/${buildingUuid}/custom_packages` : ''

  const { data, loading, error } = useFirestoreCollection<FirestoreCustomPackageDocument>(path, {
    orderByField: 'created',
    orderByDirection: 'desc', // newer to older
  })

  return {
    customPackages: data,
    loading,
    error,
  }
}
